/**
 * Australian postcode → state.
 *
 * For feeds that carry a postcode but no usable state column. ITP's allocation
 * sheet has a column headed "Small Unit Installation State", but it holds their
 * postal AREA — "Northern QLD", "Greater Sydney" — not the state, so mapping it
 * onto the address would print "Greater Brisbane QLD 4152" on a cover sheet and
 * hand geocoding a locality that does not exist.
 *
 * Ranges are the Australia Post allocations. Only the state-level split is
 * modelled: this exists to fill an address field, not to validate a postcode,
 * so an out-of-range number returns undefined and the address keeps a blank
 * state rather than a guessed one.
 */
/**
 * Ordered because the ACT and NT blocks sit INSIDE the NSW and SA number
 * spaces respectively — 2600-2618 is Canberra, not New South Wales, and 0800
 * is Darwin. First match wins, so the enclaves are listed before the ranges
 * that would otherwise swallow them.
 */
const RANGES = [
    [200, 299, 'ACT'],
    [800, 999, 'NT'],
    [2600, 2618, 'ACT'],
    [2900, 2920, 'ACT'],
    [1000, 2599, 'NSW'],
    [2619, 2899, 'NSW'],
    [2921, 2999, 'NSW'],
    [3000, 3999, 'VIC'],
    [8000, 8999, 'VIC'],
    [4000, 4999, 'QLD'],
    [9000, 9999, 'QLD'],
    [5000, 5999, 'SA'],
    [6000, 6999, 'WA'],
    [7000, 7999, 'TAS'],
];
/** The state a postcode belongs to, or undefined when it is not a real one. */
export function stateFromPostcode(postcode) {
    if (!postcode)
        return undefined;
    const trimmed = postcode.trim();
    // Four digits exactly. A partial or padded value is not enough to place a
    // point on a map, and a wrong state is worse than none.
    if (!/^\d{3,4}$/.test(trimmed))
        return undefined;
    const value = Number(trimmed);
    return RANGES.find(([low, high]) => value >= low && value <= high)?.[2];
}
//# sourceMappingURL=au-postcode.js.map